// AUTO-GENERERET — kør: npm run dictation:units:build
// Verificér før ElevenLabs: npm run dictation:units:verify

import type { DictationUnit } from './dictationUnits';

export const DICTATION_UNITS_GENERATED: DictationUnit[] = [
  // --- 3 ord ---
  { id: 'p-agnes-er-her', text: 'agnes er her', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-agnes-gaar', text: 'agnes går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-axel-er-her', text: 'axel er her', wordCount: 3, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-axel-gaar', text: 'axel går', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-barnet-er-glad', text: 'barnet er glad', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-barnet-gaar-hjem-nu', text: 'barnet går hjem nu', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'p-barnet-gaar-i-seng-nu', text: 'barnet går i seng nu', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-barnet-gaar-med-mor', text: 'barnet går med mor', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-barnet-leger-hos-mor', text: 'barnet leger hos mor', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-barnet-leger-i-haven', text: 'barnet leger i haven', wordCount: 4, minTierId: 'niveau-2', tags: ["seed"] },
  { id: 'p-barnet-leger-i-parken', text: 'barnet leger i parken', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'p-barnet-leger-med-en-bold', text: 'barnet leger med en bold', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-barnet-leger-med-hunden', text: 'barnet leger med hunden', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-barnet-leger-med-katten', text: 'barnet leger med katten', wordCount: 4, minTierId: 'niveau-2', tags: ["seed"] },
  { id: 'p-barnet-leger-paa-gulvet', text: 'barnet leger på gulvet', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-barnet-leger-paa-stranden', text: 'barnet leger på stranden', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-barnet-leger-ude-nu', text: 'barnet leger ude nu', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'p-barnet-og-mor-er-her', text: 'barnet og mor er her', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-barnet-sover', text: 'barnet sover', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-barnet-sover-hos-mor', text: 'barnet sover hos mor', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-barnet-sover-i-sengen', text: 'barnet sover i sengen', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-barnet-sover-om-natten', text: 'barnet sover om natten', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-barnet-spiser-is-nu', text: 'barnet spiser is nu', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-barnet-spiser-mad', text: 'barnet spiser mad', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-barnet-spiser-mad-nu', text: 'barnet spiser mad nu', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-barnet-spiser-med-mor', text: 'barnet spiser med mor', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-barnet-vil-have-mad', text: 'barnet vil have mad', wordCount: 4, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-bjarne-er-her', text: 'bjarne er her', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-bjarne-gaar', text: 'bjarne går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-bjoern-er-her', text: 'bjørn er her', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-bjoern-gaar', text: 'bjørn går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-bo-er-her', text: 'bo er her', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-bo-gaar', text: 'bo går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-bodil-er-her', text: 'bodil er her', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-bodil-gaar', text: 'bodil går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-boerge-er-her', text: 'børge er her', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-boerge-gaar', text: 'børge går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'p-det-er-en-god-bog', text: 'det er en god bog', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-det-er-en-hund', text: 'det er en hund', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-det-er-en-mand', text: 'det er en mand', wordCount: 4, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'p-det-er-en-ny-bog', text: 'det er en ny bog', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-det-er-en-pige', text: 'det er en pige', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-det-er-fint', text: 'det er fint', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  { id: 'p-det-er-godt', text: 'det er godt', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'p-det-er-godt-at-sove', text: 'det er godt at sove', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-det-er-lyst-nu', text: 'det er lyst nu', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-det-er-moerkt-nu', text: 'det er mørkt nu', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-det-er-rart', text: 'det er rart', wordCount: 3, minTierId: 'niveau-1', tags: ["seed"] },
  // --- 6 ord ---
  { id: 'p-det-er-rart-at-gaa-tur', text: 'det er rart at gå tur', wordCount: 6, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-det-er-sent', text: 'det er sent', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'p-det-er-tid-til-mad', text: 'det er tid til mad', wordCount: 5, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-det-regner', text: 'det regner', wordCount: 2, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-det-smager-godt', text: 'det smager godt', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-det-sner', text: 'det sner', wordCount: 2, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-drengen-er-hos-far', text: 'drengen er hos far', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-drengen-gaar', text: 'drengen går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'p-drengen-gaar-en-tur-nu', text: 'drengen går en tur nu', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-drengen-gaar-hjem-nu', text: 'drengen går hjem nu', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-drengen-gaar-med-far', text: 'drengen går med far', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-drengen-leger-hos-far', text: 'drengen leger hos far', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-drengen-leger-i-haven', text: 'drengen leger i haven', wordCount: 4, minTierId: 'niveau-2', tags: ["seed"] },
  { id: 'p-drengen-leger-i-parken', text: 'drengen leger i parken', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'p-drengen-leger-med-en-bold', text: 'drengen leger med en bold', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-drengen-leger-med-hunden', text: 'drengen leger med hunden', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-drengen-leger-paa-gulvet', text: 'drengen leger på gulvet', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-drengen-leger-paa-stranden', text: 'drengen leger på stranden', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-drengen-leger-ude-nu', text: 'drengen leger ude nu', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-drengen-og-far-gaar', text: 'drengen og far går', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'p-drengen-og-far-gaar-tur', text: 'drengen og far går tur', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-drengen-sover-hos-far', text: 'drengen sover hos far', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-drengen-sover-nu', text: 'drengen sover nu', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-drengen-sover-om-natten', text: 'drengen sover om natten', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-drengen-spiser-mad', text: 'drengen spiser mad', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'p-drengen-spiser-mad-med-far', text: 'drengen spiser mad med far', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-drengen-spiser-mad-nu', text: 'drengen spiser mad nu', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-drengen-spiser-med-far', text: 'drengen spiser med far', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-du-er-glad', text: 'du er glad', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-du-har-en-hund', text: 'du har en hund', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-du-laeser-en-bog', text: 'du læser en bog', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-du-skal-sove', text: 'du skal sove', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-ejner-er-her', text: 'ejner er her', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-ejner-gaar', text: 'ejner går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-ella-er-her', text: 'ella er her', wordCount: 3, minTierId: 'niveau-1', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-ella-gaar', text: 'ella går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-emma-er-her', text: 'emma er her', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-emma-gaar', text: 'emma går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-en-bil', text: 'en bil', wordCount: 2, minTierId: 'niveau-2', tags: ["seed"] },
  { id: 'p-en-bog', text: 'en bog', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-en-dreng', text: 'en dreng', wordCount: 2, minTierId: 'niveau-2', tags: ["seed"] },
  { id: 'p-en-far', text: 'en far', wordCount: 2, minTierId: 'niveau-2', tags: ["seed"] },
  { id: 'p-en-hund', text: 'en hund', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-en-kat', text: 'en kat', wordCount: 2, minTierId: 'niveau-2', tags: ["seed"] },
  { id: 'p-en-mand', text: 'en mand', wordCount: 2, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 6 ord ---
  { id: 'p-en-mand-og-en-kvinde-gaar', text: 'en mand og en kvinde går', wordCount: 6, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-en-mor', text: 'en mor', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-en-pige', text: 'en pige', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-en-taske', text: 'en taske', wordCount: 2, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-er-du-glad', text: 'er du glad', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-er-du-her', text: 'er du her', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-esben-er-her', text: 'esben er her', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-esben-gaar', text: 'esben går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-far-er-hjemme', text: 'far er hjemme', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-far-gaar-en-tur', text: 'far går en tur', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-far-gaar-hjem-nu', text: 'far går hjem nu', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-far-kommer-hjem-nu', text: 'far kommer hjem nu', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-far-laeser-bog', text: 'far læser bog', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'p-far-laeser-bog-for-barnet', text: 'far læser bog for barnet', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-far-laeser-en-bog', text: 'far læser en bog', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'p-far-og-barnet-gaar-hjem', text: 'far og barnet går hjem', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 6 ord ---
  { id: 'p-far-og-barnet-leger-i-parken', text: 'far og barnet leger i parken', wordCount: 6, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'p-far-og-drengen-gaar-tur', text: 'far og drengen går tur', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-far-og-drengen-laeser-bog', text: 'far og drengen læser bog', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-far-og-mor-er-her', text: 'far og mor er her', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 6 ord ---
  { id: 'p-far-og-pigen-laeser-en-bog', text: 'far og pigen læser en bog', wordCount: 6, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-far-sover-nu', text: 'far sover nu', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-far-spiser-mad-nu', text: 'far spiser mad nu', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-freja-er-her', text: 'freja er her', wordCount: 3, minTierId: 'niveau-1', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-freja-gaar', text: 'freja går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-frode-er-her', text: 'frode er her', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-frode-gaar', text: 'frode går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-gitte-er-her', text: 'gitte er her', wordCount: 3, minTierId: 'niveau-1', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-gitte-gaar', text: 'gitte går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-gry-er-her', text: 'gry er her', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-gry-gaar', text: 'gry går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-gunhild-er-her', text: 'gunhild er her', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-gunhild-gaar', text: 'gunhild går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-hanne-er-her', text: 'hanne er her', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-hanne-gaar', text: 'hanne går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-har-du-en-hund', text: 'har du en hund', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-har-du-en-kat', text: 'har du en kat', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-har-du-tid', text: 'har du tid', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-hjalte-er-her', text: 'hjalte er her', wordCount: 3, minTierId: 'niveau-1', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-hjalte-gaar', text: 'hjalte går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-holger-er-her', text: 'holger er her', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-holger-gaar', text: 'holger går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-hunden-er-glad', text: 'hunden er glad', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-hunden-leger-i-haven', text: 'hunden leger i haven', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-hunden-loeber-i-haven', text: 'hunden løber i haven', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-hunden-og-katten-sover', text: 'hunden og katten sover', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-hunden-sover', text: 'hunden sover', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-hunden-sover-nu', text: 'hunden sover nu', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-hunden-sover-om-natten', text: 'hunden sover om natten', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-hunden-sover-paa-gulvet', text: 'hunden sover på gulvet', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-hunden-sover-ved-sengen', text: 'hunden sover ved sengen', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-hunden-spiser-mad-nu', text: 'hunden spiser mad nu', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-hunden-vil-have-mad', text: 'hunden vil have mad', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-ida-er-her', text: 'ida er her', wordCount: 3, minTierId: 'niveau-1', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-ida-gaar', text: 'ida går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-inge-er-her', text: 'inge er her', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-inge-gaar', text: 'inge går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-jeg-er-glad', text: 'jeg er glad', wordCount: 3, minTierId: 'niveau-1', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-jeg-har-en-bog', text: 'jeg har en bog', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-jeg-har-tid', text: 'jeg har tid', wordCount: 3, minTierId: 'niveau-1', tags: ["seed"] },
  { id: 'p-jeg-kan-gaa', text: 'jeg kan gå', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-jeg-kan-lide-det', text: 'jeg kan lide det', wordCount: 4, minTierId: 'niveau-2', tags: ["seed"] },
  { id: 'p-jeg-kan-lide-mad', text: 'jeg kan lide mad', wordCount: 4, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-jeg-kommer-snart', text: 'jeg kommer snart', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-jeg-laeser-en-bog', text: 'jeg læser en bog', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-jesper-er-her', text: 'jesper er her', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-jesper-gaar', text: 'jesper går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-jette-er-her', text: 'jette er her', wordCount: 3, minTierId: 'niveau-1', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-jette-gaar', text: 'jette går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-joergen-er-her', text: 'jørgen er her', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-joergen-gaar', text: 'jørgen går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-katten-er-sort', text: 'katten er sort', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-katten-leger-ikke', text: 'katten leger ikke', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-katten-sover', text: 'katten sover', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-katten-sover-nu', text: 'katten sover nu', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-katten-sover-paa-gulvet', text: 'katten sover på gulvet', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-katten-sover-paa-sofaen', text: 'katten sover på sofaen', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-katten-sover-ved-sengen', text: 'katten sover ved sengen', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-katten-spiser-mad', text: 'katten spiser mad', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-katten-vil-have-mad', text: 'katten vil have mad', wordCount: 4, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-kirsten-er-her', text: 'kirsten er her', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-kirsten-gaar', text: 'kirsten går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-knud-er-her', text: 'knud er her', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-knud-gaar', text: 'knud går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-kommer-du-snart', text: 'kommer du snart', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-kaare-er-her', text: 'kåre er her', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-kaare-gaar', text: 'kåre går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-lene-er-her', text: 'lene er her', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-lene-gaar', text: 'lene går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-liv-er-her', text: 'liv er her', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-liv-gaar', text: 'liv går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-lone-er-her', text: 'lone er her', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-lone-gaar', text: 'lone går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-lotte-er-her', text: 'lotte er her', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-lotte-gaar', text: 'lotte går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-laerke-er-her', text: 'lærke er her', wordCount: 3, minTierId: 'niveau-1', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-laerke-gaar', text: 'lærke går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-mads-er-her', text: 'mads er her', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-mads-gaar', text: 'mads går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-manden-er-her', text: 'manden er her', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-manden-gaar', text: 'manden går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-manden-gaar-en-tur', text: 'manden går en tur', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-manden-gaar-hjem-nu', text: 'manden går hjem nu', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-manden-har-en-hund', text: 'manden har en hund', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-manden-laeser-en-bog', text: 'manden læser en bog', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-mette-er-her', text: 'mette er her', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-mette-gaar', text: 'mette går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-mia-er-her', text: 'mia er her', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-mia-gaar', text: 'mia går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-mogens-er-her', text: 'mogens er her', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-mogens-gaar', text: 'mogens går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-mor-er-hjemme', text: 'mor er hjemme', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-mor-gaar-en-tur', text: 'mor går en tur', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-mor-gaar-hjem-nu', text: 'mor går hjem nu', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-mor-laver-mad', text: 'mor laver mad', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-mor-laver-mad-nu', text: 'mor laver mad nu', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 6 ord ---
  { id: 'p-mor-laver-mad-og-far-spiser', text: 'mor laver mad og far spiser', wordCount: 6, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'p-mor-laver-mad-til-barnet', text: 'mor laver mad til barnet', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-mor-og-barnet-er-her', text: 'mor og barnet er her', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 6 ord ---
  { id: 'p-mor-og-barnet-er-i-haven', text: 'mor og barnet er i haven', wordCount: 6, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-mor-og-barnet-gaar-en-tur', text: 'mor og barnet går en tur', wordCount: 6, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'p-mor-og-barnet-gaar-hjem', text: 'mor og barnet går hjem', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 6 ord ---
  { id: 'p-mor-og-barnet-leger-i-haven', text: 'mor og barnet leger i haven', wordCount: 6, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'p-mor-og-far-er-her', text: 'mor og far er her', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-mor-og-far-er-hjemme', text: 'mor og far er hjemme', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 6 ord ---
  { id: 'p-mor-og-far-gaar-en-tur', text: 'mor og far går en tur', wordCount: 6, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'p-mor-og-far-sover-nu', text: 'mor og far sover nu', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-mor-og-far-spiser-mad', text: 'mor og far spiser mad', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-mor-og-pigen-gaar-tur', text: 'mor og pigen går tur', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-mor-ringer-til-far', text: 'mor ringer til far', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-mor-sover-nu', text: 'mor sover nu', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-mor-spiser-mad-nu', text: 'mor spiser mad nu', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-nanna-er-her', text: 'nanna er her', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-nanna-gaar', text: 'nanna går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-niels-er-her', text: 'niels er her', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-niels-gaar', text: 'niels går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-ole-er-her', text: 'ole er her', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-ole-gaar', text: 'ole går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-olivia-er-her', text: 'olivia er her', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-olivia-gaar', text: 'olivia går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-pia-er-her', text: 'pia er her', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-pia-gaar', text: 'pia går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-pigen-er-her', text: 'pigen er her', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-pigen-er-hos-mor', text: 'pigen er hos mor', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-pigen-gaar', text: 'pigen går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-pigen-gaar-en-tur', text: 'pigen går en tur', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'p-pigen-gaar-en-tur-nu', text: 'pigen går en tur nu', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-pigen-gaar-hjem-nu', text: 'pigen går hjem nu', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-pigen-gaar-med-mor', text: 'pigen går med mor', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-pigen-har-en-kat', text: 'pigen har en kat', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-pigen-leger-hos-mor', text: 'pigen leger hos mor', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-pigen-leger-i-haven', text: 'pigen leger i haven', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-pigen-leger-i-parken', text: 'pigen leger i parken', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'p-pigen-leger-med-en-bold', text: 'pigen leger med en bold', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-pigen-leger-med-katten', text: 'pigen leger med katten', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-pigen-leger-paa-gulvet', text: 'pigen leger på gulvet', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-pigen-leger-paa-stranden', text: 'pigen leger på stranden', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-pigen-leger-ude-nu', text: 'pigen leger ude nu', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-pigen-laeser-en-bog', text: 'pigen læser en bog', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-pigen-og-drengen-leger', text: 'pigen og drengen leger', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 6 ord ---
  { id: 'p-pigen-og-drengen-leger-i-haven', text: 'pigen og drengen leger i haven', wordCount: 6, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-pigen-og-drengen-leger-i-parken', text: 'pigen og drengen leger i parken', wordCount: 6, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-pigen-og-drengen-sover', text: 'pigen og drengen sover', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'p-pigen-og-drengen-spiser-mad', text: 'pigen og drengen spiser mad', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-pigen-og-mor-gaar', text: 'pigen og mor går', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'p-pigen-og-mor-gaar-tur', text: 'pigen og mor går tur', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-pigen-og-mor-laver-mad', text: 'pigen og mor laver mad', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-pigen-sover-hos-mor', text: 'pigen sover hos mor', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-pigen-sover-i-sengen', text: 'pigen sover i sengen', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-pigen-sover-nu', text: 'pigen sover nu', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-pigen-sover-om-natten', text: 'pigen sover om natten', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-pigen-spiser-is', text: 'pigen spiser is', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'p-pigen-spiser-is-med-mor', text: 'pigen spiser is med mor', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-pigen-spiser-is-nu', text: 'pigen spiser is nu', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-pigen-spiser-mad-nu', text: 'pigen spiser mad nu', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-pigen-spiser-med-mor', text: 'pigen spiser med mor', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-pigen-vil-have-is', text: 'pigen vil have is', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-pil-er-her', text: 'pil er her', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-pil-gaar', text: 'pil går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-poul-er-her', text: 'poul er her', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-poul-gaar', text: 'poul går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-preben-er-her', text: 'preben er her', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-preben-gaar', text: 'preben går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-rasmus-er-her', text: 'rasmus er her', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-rasmus-gaar', text: 'rasmus går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-rikke-er-her', text: 'rikke er her', wordCount: 3, minTierId: 'niveau-1', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-rikke-gaar', text: 'rikke går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-sanne-er-her', text: 'sanne er her', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-sanne-gaar', text: 'sanne går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-signe-er-her', text: 'signe er her', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-signe-gaar', text: 'signe går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'p-skal-vi-gaa-en-tur', text: 'skal vi gå en tur', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 6+ (7–12 ord) ---
  { id: 's-skal-vi-gaa-en-tur-i-dag', text: 'skal vi gå en tur i dag', wordCount: 7, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 6 ord ---
  { id: 'p-skal-vi-gaa-en-tur-nu', text: 'skal vi gå en tur nu', wordCount: 6, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-skal-vi-gaa-tur', text: 'skal vi gå tur', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'p-skal-vi-lave-mad-nu', text: 'skal vi lave mad nu', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-skal-vi-spise-mad-nu', text: 'skal vi spise mad nu', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-skal-vi-spise-nu', text: 'skal vi spise nu', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-sofie-er-her', text: 'sofie er her', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-sofie-gaar', text: 'sofie går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-sol-skinner', text: 'sol skinner', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-stig-er-her', text: 'stig er her', wordCount: 3, minTierId: 'niveau-1', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-stig-gaar', text: 'stig går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-svend-er-her', text: 'svend er her', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-svend-gaar', text: 'svend går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-soeren-er-her', text: 'søren er her', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-soeren-gaar', text: 'søren går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-tage-er-her', text: 'tage er her', wordCount: 3, minTierId: 'niveau-1', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-tage-gaar', text: 'tage går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-torben-er-her', text: 'torben er her', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-torben-gaar', text: 'torben går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-tove-er-her', text: 'tove er her', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-tove-gaar', text: 'tove går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-trine-er-her', text: 'trine er her', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-trine-gaar', text: 'trine går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-tue-er-her', text: 'tue er her', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-tue-gaar', text: 'tue går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-ulla-er-her', text: 'ulla er her', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-ulla-gaar', text: 'ulla går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-vi-er-her', text: 'vi er her', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-vi-gaar-en-tur', text: 'vi går en tur', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 6 ord ---
  { id: 'p-vi-gaar-en-tur-i-dag', text: 'vi går en tur i dag', wordCount: 6, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-vi-gaar-hjem-nu', text: 'vi går hjem nu', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-vi-har-en-kat', text: 'vi har en kat', wordCount: 4, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-vi-kan-gaa', text: 'vi kan gå', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 6+ (7–12 ord) ---
  { id: 's-vi-skal-gaa-en-tur-i-dag', text: 'vi skal gå en tur i dag', wordCount: 7, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 6 ord ---
  { id: 'p-vi-skal-gaa-en-tur-nu', text: 'vi skal gå en tur nu', wordCount: 6, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'p-vi-skal-lave-mad-nu', text: 'vi skal lave mad nu', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-vi-skal-sove', text: 'vi skal sove', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-vi-skal-sove-nu', text: 'vi skal sove nu', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'p-vi-skal-spise-mad-nu', text: 'vi skal spise mad nu', wordCount: 5, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'p-vi-skal-spise-nu', text: 'vi skal spise nu', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'p-vi-spiser-mad-nu', text: 'vi spiser mad nu', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-vibeke-er-her', text: 'vibeke er her', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-vibeke-gaar', text: 'vibeke går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-viggo-er-her', text: 'viggo er her', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-viggo-gaar', text: 'viggo går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-oejvind-er-her', text: 'øjvind er her', wordCount: 3, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-oejvind-gaar', text: 'øjvind går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-aage-er-her', text: 'åge er her', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-aage-gaar', text: 'åge går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'p-aase-er-her', text: 'åse er her', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'p-aase-gaar', text: 'åse går', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 1 ord ---
  { id: 'w-ad', text: 'ad', wordCount: 1, minTierId: 'grundniveau', tags: ["word"] },
  { id: 'w-alfa', text: 'alfa', wordCount: 1, minTierId: 'grundniveau', tags: ["word"] },
  { id: 'w-altid', text: 'altid', wordCount: 1, minTierId: 'niveau-1', tags: ["word"] },
  { id: 'w-anden', text: 'anden', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-arbejde', text: 'arbejde', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-arbejder', text: 'arbejder', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-barn', text: 'barn', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-ben', text: 'ben', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-benet', text: 'benet', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-bland', text: 'bland', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-blandt', text: 'blandt', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-blive', text: 'blive', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-bliver', text: 'bliver', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-bly', text: 'bly', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-bon', text: 'bon', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'w-brev', text: 'brev', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-brevet', text: 'brevet', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-bruge', text: 'bruge', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'w-bruger', text: 'bruger', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'w-bryde', text: 'bryde', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-by', text: 'by', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-byde', text: 'byde', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-byen', text: 'byen', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-bygning', text: 'bygning', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-bygningen', text: 'bygningen', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-baenk', text: 'bænk', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-boen', text: 'bøn', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-boern', text: 'børn', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-baad', text: 'båd', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'w-center', text: 'center', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'w-chance', text: 'chance', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'w-cirkel', text: 'cirkel', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'w-citron', text: 'citron', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'w-cykel', text: 'cykel', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'w-da', text: 'da', wordCount: 1, minTierId: 'grundniveau', tags: ["word"] },
  { id: 'w-dal', text: 'dal', wordCount: 1, minTierId: 'grundniveau', tags: ["word"] },
  { id: 'w-dansk', text: 'dansk', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-dele', text: 'dele', wordCount: 1, minTierId: 'niveau-1', tags: ["word"] },
  { id: 'w-drop', text: 'drop', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'w-daek', text: 'dæk', wordCount: 1, minTierId: 'grundniveau', tags: ["word"] },
  { id: 'w-doer', text: 'dør', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-eje', text: 'eje', wordCount: 1, minTierId: 'niveau-1', tags: ["word"] },
  { id: 'w-ekstra', text: 'ekstra', wordCount: 1, minTierId: 'niveau-1', tags: ["word"] },
  { id: 'w-elev', text: 'elev', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-eleven', text: 'eleven', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-fad', text: 'fad', wordCount: 1, minTierId: 'grundniveau', tags: ["word"] },
  { id: 'w-fald', text: 'fald', wordCount: 1, minTierId: 'grundniveau', tags: ["word"] },
  { id: 'w-falsk', text: 'falsk', wordCount: 1, minTierId: 'grundniveau', tags: ["word"] },
  { id: 'w-familie', text: 'familie', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-fare', text: 'fare', wordCount: 1, minTierId: 'niveau-1', tags: ["word"] },
  { id: 'w-fart', text: 'fart', wordCount: 1, minTierId: 'niveau-1', tags: ["word"] },
  { id: 'w-fax', text: 'fax', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'w-file', text: 'file', wordCount: 1, minTierId: 'niveau-1', tags: ["word"] },
  { id: 'w-find', text: 'find', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-finger', text: 'finger', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-fix', text: 'fix', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'w-flak', text: 'flak', wordCount: 1, minTierId: 'grundniveau', tags: ["word"] },
  { id: 'w-flaesk', text: 'flæsk', wordCount: 1, minTierId: 'grundniveau', tags: ["word"] },
  { id: 'w-fred', text: 'fred', wordCount: 1, minTierId: 'niveau-1', tags: ["word"] },
  { id: 'w-fri', text: 'fri', wordCount: 1, minTierId: 'niveau-1', tags: ["word"] },
  { id: 'w-fundet', text: 'fundet', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'w-fyret', text: 'fyret', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-foele', text: 'føle', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-foeler', text: 'føler', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-foelge', text: 'følge', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-foelger', text: 'følger', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-foelte', text: 'følte', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-foerste', text: 'første', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-gade', text: 'gade', wordCount: 1, minTierId: 'niveau-1', tags: ["word"] },
  { id: 'w-gaden', text: 'gaden', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-gerne', text: 'gerne', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-gift', text: 'gift', wordCount: 1, minTierId: 'niveau-1', tags: ["word"] },
  { id: 'w-grad', text: 'grad', wordCount: 1, minTierId: 'niveau-1', tags: ["word"] },
  { id: 'w-grund', text: 'grund', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'w-han', text: 'han', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-hele', text: 'hele', wordCount: 1, minTierId: 'niveau-1', tags: ["word"] },
  { id: 'w-helt', text: 'helt', wordCount: 1, minTierId: 'niveau-1', tags: ["word"] },
  { id: 'w-hest', text: 'hest', wordCount: 1, minTierId: 'niveau-1', tags: ["word"] },
  { id: 'w-holde', text: 'holde', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'w-hop', text: 'hop', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'w-hoppe', text: 'hoppe', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'w-hoved', text: 'hoved', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'w-hovedet', text: 'hovedet', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'w-hun', text: 'hun', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'w-hus', text: 'hus', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'w-husene', text: 'husene', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'w-huset', text: 'huset', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'w-huske', text: 'huske', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'w-haand', text: 'hånd', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'w-ide', text: 'ide', wordCount: 1, minTierId: 'niveau-1', tags: ["word"] },
  { id: 'w-ja', text: 'ja', wordCount: 1, minTierId: 'grundniveau', tags: ["word"] },
  { id: 'w-kald', text: 'kald', wordCount: 1, minTierId: 'grundniveau', tags: ["word"] },
  { id: 'w-klasse', text: 'klasse', wordCount: 1, minTierId: 'niveau-1', tags: ["word"] },
  { id: 'w-klassen', text: 'klassen', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-klog', text: 'klog', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'w-komme', text: 'komme', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'w-kone', text: 'kone', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'w-kop', text: 'kop', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'w-kor', text: 'kor', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'w-kraft', text: 'kraft', wordCount: 1, minTierId: 'niveau-1', tags: ["word"] },
  { id: 'w-krog', text: 'krog', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'w-krop', text: 'krop', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'w-kraefter', text: 'kræfter', wordCount: 1, minTierId: 'niveau-1', tags: ["word"] },
  { id: 'w-kaelk', text: 'kælk', wordCount: 1, minTierId: 'grundniveau', tags: ["word"] },
  { id: 'w-lad', text: 'lad', wordCount: 1, minTierId: 'grundniveau', tags: ["word"] },
  { id: 'w-laks', text: 'laks', wordCount: 1, minTierId: 'grundniveau', tags: ["word"] },
  { id: 'w-land', text: 'land', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-leder', text: 'leder', wordCount: 1, minTierId: 'niveau-1', tags: ["word"] },
  { id: 'w-lektion', text: 'lektion', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'w-lidt', text: 'lidt', wordCount: 1, minTierId: 'niveau-1', tags: ["word"] },
  { id: 'w-lille', text: 'lille', wordCount: 1, minTierId: 'niveau-1', tags: ["word"] },
  { id: 'w-laerer', text: 'lærer', wordCount: 1, minTierId: 'niveau-1', tags: ["word"] },
  { id: 'w-laereren', text: 'læreren', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-laes', text: 'læs', wordCount: 1, minTierId: 'grundniveau', tags: ["word"] },
  { id: 'w-laese', text: 'læse', wordCount: 1, minTierId: 'niveau-1', tags: ["word"] },
  { id: 'w-loeb', text: 'løb', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-mark', text: 'mark', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-meget', text: 'meget', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-melde', text: 'melde', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'w-mellem', text: 'mellem', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
];
